import React, { Component } from "react";
import { Button, Badge } from "antd";
import List from "./shared/list";
import FullScreenModal from "components/utils/fullScreenModal";

export default class TarotsPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  visibleChangeHandler = (visible) => {
    !visible && this.close();
  };

  close = () => this.setState({ visible: false });

  open = () => this.setState({ visible: true });

  handleButtonClick = () => {
    this.state.visible ? this.close() : this.open();
  };

  render() {
    const { value, onChange } = this.props.input;
    return (
      <>
        <FullScreenModal
          open={this.state.visible}
          onCancel={this.close}
          title="Tarots"
        >
          <List tarots={this.props.tarots} value={value} onChange={onChange} />
        </FullScreenModal>
        <Badge count={value ? 1 : 0}>
          <Button type="primary" ghost onClick={this.open}>
            Tarots
          </Button>
        </Badge>
      </>
    );
  }
}
